
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */
import { assertIsFn, AddContext } from "@storybook/addon-docs";

import { Canvas, Meta, Story } from '@storybook/addon-docs';
import basicDemo from './demo/basic.twig';
import advancedDemo from './demo/advanced.twig'; // The '!!raw-loader!' syntax is a non-standard, Webpack-specific, syntax.
// See: https://github.com/webpack-contrib/raw-loader#examples
// For now, it seems likely Storybook is pretty tied to Webpack, therefore, we are
// okay with the following Webpack-specific raw loader syntax. It's better to leave
// the ESLint rule enabled globally, and only thoughtfully disable as needed (e.g.
// within a Storybook docs page and not within an actual component).
// This can be revisited in the future if Storybook no longer relies on Webpack.
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import basicDemoSource from '!!raw-loader!./demo/basic.twig';
// eslint-disable-next-line @cloudfour/import/no-webpack-loader-syntax
import advancedDemoSource from '!!raw-loader!./demo/advanced.twig';
import topics from '../../components/dot-leader/demo/topics.json';


const layoutProps = {
  
};
const MDXLayout = "wrapper"
function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    {/*
     Inline stories disabled so media queries will behave as expected within
     embedded examples.
     */}
    <Meta title="Objects/Overview" parameters={{
      docs: {
        inlineStories: false
      }
    }} mdxType="Meta" />
    <h1>{`Overview`}</h1>
    <p>{`The Overview object can be used to provide an overview of a site section. For example, it is used to provide an index of article categories, as well as a form to search for articles.`}</p>
    <p>{`It handles the responsive layout of `}<inlineCode parentName="p">{`header`}</inlineCode>{`, `}<inlineCode parentName="p">{`actions`}</inlineCode>{`, and `}<inlineCode parentName="p">{`content`}</inlineCode>{` blocks. On small screens they are stacked vertically. On large screens the `}<inlineCode parentName="p">{`header`}</inlineCode>{` and `}<inlineCode parentName="p">{`actions`}</inlineCode>{` blocks stack horizontally above the `}<inlineCode parentName="p">{`content`}</inlineCode>{` block.`}</p>
    <p>{`It should usually be placed in a `}<a parentName="p" {...{
        "href": "/docs/objects-container--basic"
      }}>{`Container`}</a>{`.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Basic" height="300px" parameters={{
        docs: {
          source: {
            code: basicDemoSource
          }
        }
      }} mdxType="Story">
    {basicDemo()}
  </Story>
    </Canvas>
    <h2>{`Advanced Usage`}</h2>
    <p>{`Here's a more complex usage example, showing how the Overview object could be used on the article listing page.`}</p>
    <Canvas mdxType="Canvas">
  <Story name="Advanced Usage" height="300px" parameters={{
        docs: {
          source: {
            code: advancedDemoSource
          }
        }
      }} mdxType="Story">
    {advancedDemo({
          topics
        })}
  </Story>
    </Canvas>
    <h2>{`Template Properties`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`overview_tag`}</inlineCode>{` - defaults to `}<inlineCode parentName="li">{`section`}</inlineCode>{` but can be switched out for any HTML tag.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`labelledby_id`}</inlineCode>{` - an optional ID to use with the `}<inlineCode parentName="li">{`aria-labelledby`}</inlineCode>{` attribute.`}</li>
    </ul>
    <h2>{`Template blocks`}</h2>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`header`}</inlineCode>{` - should generally contain a `}<a parentName="li" {...{
          "href": "/docs/components-heading--levels"
        }}>{`Heading`}</a></li>
      <li parentName="ul"><inlineCode parentName="li">{`actions`}</inlineCode>{` - could contain a searchbar or other actions`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`content`}</inlineCode>{` the primary overview content. For example, a list of categories.`}</li>
    </ul>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

export const basic = () => (
          basicDemo()
        );
basic.storyName = 'Basic';
basic.parameters = { storySource: { source: 'basicDemo()' }, ...{
  docs: {
    source: {
      code: basicDemoSource
    }
  }
} };

export const advancedUsage = () => (
          advancedDemo({
  topics
})
        );
advancedUsage.storyName = 'Advanced Usage';
advancedUsage.parameters = { storySource: { source: 'advancedDemo({\n  topics\n})' }, ...{
  docs: {
    source: {
      code: advancedDemoSource
    }
  }
} };

const componentMeta = { title: 'Objects/Overview', parameters: {
  docs: {
    inlineStories: false
  }
}, includeStories: ["basic","advancedUsage"],  };

const mdxStoryNameToKey = {"Basic":"basic","Advanced Usage":"advancedUsage"};

componentMeta.parameters = componentMeta.parameters || {};
componentMeta.parameters.docs = {
  ...(componentMeta.parameters.docs || {}),
  page: () => <AddContext mdxStoryNameToKey={mdxStoryNameToKey} mdxComponentAnnotations={componentMeta}><MDXContent /></AddContext>,
};

export default componentMeta;